import styled from "styled-components";

export const StyledShortAnswer = styled.div`
    height: 45px;
    width: 80%;
    input {
        height: 43px;
        border-radius: 6px;
        background-color: #E5F3FF;
        border: 0;
        width: 100%;
    }
`